<template>
  <div>
    <!-- Titre Main -->
    <Titre
      v-if="content.libTitreSection"
      :content="{
        titre: content.libTitreSection,
        type: 'grandTitre pt-0 pb-3 mb-0',
      }"
      class="title-secondary title-main"
    ></Titre>
    <!-- Description Main -->
    <Paragraphe
      v-if="content.libSousTitreSection"
      :content="{
        richText: content.libSousTitreSection,
        classeCSS: 'pb-0',
      }"
      class="texte-desc"
    ></Paragraphe>
    <!-- Section Depot Semaines -->
    <section class="section-depot-semaines">
      <LimiteDepotChoix
        :category="categories[0]"
        :period="period"
        :content="content"
        :title="content.titreDeposit"
        :texte="content.descriptionDeposit"
        :initialValue="limits[categories[0]] || null"
        @confirm-changed="handleConfirmChanged"
      />
    </section>
    <!-- Section limite temps et pertes -->
    <section v-show="showSection" class="section-outils">
      <div class="section-outils-grey">
        <!-- Titre Main -->
        <Titre
          v-if="content.libTitreSectionOutils"
          :content="{
            titre: content.libTitreSectionOutils,
            type: 'titre pt-0 pb-1 mb-0',
          }"
          class="title-secondary title-main"
        ></Titre>
        <!-- Description Main -->
        <Paragraphe
          v-if="content.libSousTitreSectionOutils"
          :content="{
            richText: content.libSousTitreSectionOutils,
            classeCSS: 'pb-1',
          }"
          class="texte-desc"
        ></Paragraphe>
        <div
          v-for="(item, index) in outilsSections"
          :key="item.category"
          :class="item.containerClass"
        >
          <LimiteDepotChoix
            :category="item.category"
            :period="period"
            :content="content"
            :title="item.title"
            :texte="item.text"
            :initialValue="limits[item.category] || null"
            @show-message="handleShowMessage"
          />
        </div>
        <Paragraphe
          v-if="content.txtDelaisWeek"
          :content="{
            richText: content.txtDelaisWeek,
            classeCSS: 'pt-1 note',
          }"
          class="texte-legal"
        ></Paragraphe>
      </div>
    </section>
    <!-- Message Avertissement -->
    <div v-show="showConfirmBtn">
      <div
        v-if="content.txtWarningMessage"
        class="warning-box"
        v-html="content.txtWarningMessage"
      ></div>
    </div>
    <div class="btn-right">
      <button
        type="button"
        class="btn btn-next px-6 mb-0 btn-primaire"
        :disabled="!isConfirmed"
        tabindex="0"
        @click="nextDepot"
      >
        <span>{{ content.libBtnFormNext }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import LimiteDepotChoix from '@/components/formulaire/compte/LimiteDepotChoix';
import Paragraphe from '@/components/base/Paragraphe';
import Titre from '@/components/base/Titre';
import encadrerJeux from '@/services/api/compte/encadrerJeux';
import { PageMapping } from '@/helpers/PageMappingHelpers';

export default {
  name: 'LimiteDepotSection',
  components: {
    LimiteDepotChoix,
    Paragraphe,
    Titre,
  },
  props: {
    content: { type: Object, required: true },
    period: { type: String },
    categories: { type: Array },
  },
  data() {
    return {
      limits: {},
      showSection: false,
      actualValue: null,
      isConfirmed: false,
      showConfirmBtn: false,
      isErreurServeur: false,
      outilsSections: [],
    };
  },
  created() {
    this.outilsSections = [
      {
        category: this.categories[1],
        title: this.content.titreTime,
        text: this.content.descriptionTime,
        containerClass: 'limite-depot-temps',
      },
      {
        category: this.categories[2],
        title: this.content.titreLoss,
        text: this.content.descriptionLoss,
        containerClass: 'limite-depot-pertes',
      },
    ];
  },
  async mounted() {
    await Promise.all([
      this.getDataLimit(this.categories[0]),
      this.getDataLimit(this.categories[1]),
      this.getDataLimit(this.categories[2]),
    ]);

    // Show Section if Time or Loss does not exist
    const timeLimitEmpty = !this.limits.time || Object.keys(this.limits.time).length === 0;
    const lossLimitEmpty = !this.limits.loss || Object.keys(this.limits.loss).length === 0;

    this.showSection = timeLimitEmpty && lossLimitEmpty;

    // Bypass page if deposit actuel Limit is already set
    if (!this.limits.deposit?.week?.actuelLimit) {
      return false;
    }
    this.$router.push({ path: this.content.libBtnFormNextLink });
  },

  methods: {
    async getDataLimit(cat) {
      try {
        const data = await encadrerJeux.getLimiteJeux(cat);
        // console.log(data, cat);
        const parsedData = this.isTypeString(data)
          ? JSON.parse(data.replace(/,\s*(?=[}\]])/g, ''))
          : data;
        this.$set(this.limits, cat, parsedData?.[cat]);
      } catch (error) {
        // console.error('error', error);
        this.showSection = false;
        this.isErreurServeur = true;
      }
    },
    isTypeString(value) {
      return typeof value === 'string' || value instanceof String;
    },
    handleConfirmChanged(value) {
      this.isConfirmed = value;
    },
    handleShowMessage(newValue) {
      this.showConfirmBtn = newValue;
    },
    nextDepot() {
      if (this.limits[this.categories[0]]?.week?.actuelLimit !== null) {
        this.$router.push({ path: this.content.libBtnFormNextLink });
      } else {
        this.isConfirmed = false;
        if (this.limits[this.categories[0]] === null) {
          this.$router.push({ path: PageMapping.ERREUR_GENERIQUE.siteUrl });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.titre {
  font-size: 4rem;
}

.title-main {
  font-family: 'graphik_semibold';
}

.btn-learn {
  text-decoration: underline;
  font-weight: bold;
  color: #192872;
}

.section-depot-semaines {
  background-color: #e9f6fe;
  padding: 24px 16px;
  border-radius: 16px;
  margin-bottom: 2.5rem;
}

.section-outils {
  border-radius: 16px;
  border: 1px solid black;
  padding: 24px 16px;

  .limite-depot-temps {
    background-color: #f7f7f7;
    padding: 16px;
    border-radius: 8px;
  }

  .limite-depot-pertes {
    background-color: #f7f7f7;
    padding: 16px;
    border-radius: 8px;
    margin-top: 48px;
  }

  .note {
    font-size: 16px;
    font-style: normal;
    line-height: 150%;
  }
}

.warning-box {
  background-color: #fdf3d1;
  padding: 0.5rem;
  font-size: 14px;
  font-family: 'graphik_regular';
  margin-top: 1rem;
  border-radius: 8px;
  ::v-deep p {
    margin-bottom: 0;
  }
}

.btn-right {
  display: flex;
  justify-content: flex-start;
  margin-top: 2rem;
  .btn-next {
    box-shadow: none;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 32px;
    border: 1px solid #192872;
    font-family: 'graphik_semibold';
    background: #192872;
    color: #a6ecff;
    &:focus,
    &:focus-visible {
      outline-offset: 7px;
      outline: 2px solid black;
    }
    @include media-breakpoint-down(xs) {
      width: 100%;
    }
    &.disabled,
    &:disabled {
      opacity: 50%;
      cursor: not-allowed;
    }
    &:not(.disabled):not(:disabled):active,
    &:not(.disabled):not(:disabled):focus,
    &:not(.disabled):not(:disabled):hover {
      opacity: 100%;
      cursor: pointer;
    }
  }
}
</style>
